import { EN_SHOME_TARGET_TYPE } from '@@sapporo/constant/enum/sHome/EN_SHOME_TARGET';
import { ISHomeBenefit } from '@@sapporo/shome/benefit/interface/ISHomeBenefit';
import SHomeActions from '@/models/SHome/SHomeActions';
import SHomeRequestBuilder from '@/models/SHome/SHomeRequestBuilder';
import { nullish } from '@/utils/yambda';
import { action, computed, observable } from 'mobx';
import { prop } from 'ramda';

/**
 * KTX 서브홈, 마이페이지 용 구 베네핏 배너
 * (추후 신규 베네핏 배너 API로 이관될 예정)
 */
export class SHomeBenefitBannerStore {
  @observable isLoading = false;

  private action = new SHomeActions(SHomeRequestBuilder);

  constructor(private target: EN_SHOME_TARGET_TYPE, private banner: ISHomeBenefit | null = null) {}

  @computed
  get Banner(): ISHomeBenefit | null {
    return this.banner;
  }

  @action.bound
  async load(): Promise<void> {
    this.isLoading = true;

    const result = await this.action.benefitBanner({
      query: { target: this.target },
    });

    this.banner = result.caseOf({
      left: nullish,
      right: prop('data'),
    });

    this.isLoading = false;
  }
}
